import React, { useState, useCallback } from 'react';
import { useFormContext, useWatch, Controller } from 'react-hook-form';
import { Radio, RadioGroup } from '@ds';
import { AdminFormRow, ConfirmationModal } from '@ui';
import { TXUserBaseFormType } from '@/types/customer';
import { IS_ACTIVE_TXUSER } from '../../TXUserFormBase';

type Props = {
  isReadOnly?: boolean;
};

export const TXUserActiveStatus = React.memo(({ isReadOnly }: Props) => {
  const { control, setValue } = useFormContext<TXUserBaseFormType>();
  const enabled = useWatch({ control, name: 'enabled' });
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);

  const onConfirmationModalClose = useCallback(() => {
    setConfirmationModalOpen(false);
  }, []);

  const onChangeActive = useCallback(async () => {
    setValue('enabled', !enabled, { shouldDirty: true });
    setConfirmationModalOpen(false);
  }, [enabled, setValue]);

  return (
    <>
      <AdminFormRow title="Active account" isRequired={false} inputWrapperClass="max-w-160">
        <Controller
          name="enabled"
          control={control}
          render={({ field: { value, onChange, ...field }, fieldState: { invalid, error } }) => (
            <RadioGroup
              className="gap-8"
              orientation="horizontal"
              value={value as unknown as string}
              isInvalid={invalid}
              errorMessage={error?.message}
              onValueChange={() => setConfirmationModalOpen(true)}
              {...field}
            >
              {IS_ACTIVE_TXUSER.map((isActive) => (
                <Radio
                  isDisabled={isReadOnly}
                  className="w-[100px] max-w-none"
                  key={isActive.value as string}
                  value={isActive.value as string}
                  size="lg"
                >
                  {isActive.name}
                </Radio>
              ))}
            </RadioGroup>
          )}
        />
      </AdminFormRow>
      <ConfirmationModal
        title="Change TX User active status"
        description="Are you sure you want to change the active status?"
        isOpen={confirmationModalOpen}
        onChangeActive={onChangeActive}
        onClose={onConfirmationModalClose}
      />
    </>
  );
});

TXUserActiveStatus.displayName = 'TXUserActiveStatus';
